/**
 * LinearProgress Variants
 *
 * CVA variants for the LinearProgress component.
 * Exported separately to comply with React Fast Refresh requirements.
 *
 * @see LinearProgress.tsx for component implementation
 */

import {cva} from'class-variance-authority';

export const linearProgressVariants = cva(
'relative w-full overflow-hidden rounded-full',
 {
 variants: {
 size: {
 xs:'h-1',
 sm:'h-1.5',
 md:'h-2',
 lg:'h-3',
 xl:'h-4',
 },
 variant: {
 default:'bg-[hsl(var(--neutral-color)/0.2)]',
 primary:'bg-[hsl(var(--primary-color)/0.2)]',
 accent:'bg-[hsl(var(--accent-color)/0.2)]',
 success:'bg-green-200',
 warning:'bg-[hsl(var(--warm-color)/0.2)]',
 destructive:'bg-[hsl(var(--destructive)/0.2)]',
 },
 },
 defaultVariants: {
 size:'md',
 variant:'default',
 },
 }
);

export const progressBarVariants = cva(
'h-full rounded-full transition-all duration-300 ease-out',
 {
 variants: {
 variant: {
 default:'bg-[hsl(var(--accent-color))]',
 primary:'bg-[hsl(var(--primary-color))]',
 accent:'bg-[hsl(var(--accent-color))]',
 success:'bg-green-500',
 warning:'bg-[hsl(var(--warm-color))]',
 destructive:'bg-[hsl(var(--destructive))]',
 },
 style: {
 solid:'',
 gradient:'bg-gradient-to-r from-[hsl(var(--primary-color))] via-[hsl(var(--accent-color))] to-[hsl(var(--secondary-color))]',
 striped:'bg-gradient-to-r from-transparent via-card/20 to-transparent bg-[length:20px_100%]',
 },
 },
 defaultVariants: {
 variant:'default',
 style:'solid',
 },
 }
);
